import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBTextAreaObjective, DBTextField, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestCTSIB extends React.Component {

    handleDiagChange(event, stage) {    
            if (event.target.value === '-1') {
                this.props.clearField(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, stage);
            }
            else if (event.target.value === '1') {
                this.props.updateTextField(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, stage, 'Hip')
            }
            else if (event.target.value === '2') {
                this.props.updateTextField(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, stage, 'Ankle')
            }
            else if (event.target.value === '3') {
                this.props.updateTextField(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, stage, '')
            }
    }
    
    render() {      
        return (
            <div>
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSCTSIBEYEOPENFIRM} mopno={this.props.mopno} flagText='Special Test - mCTSIB'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Eyes Open (30 Sec Firm Surface)</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSCTSIBEYEOPENFIRMTIME'
                        className={styles.out_measure_other}
                        />
                        <span className={styles.spacer} />
                        <select className={styles.diag_drop_down} onChange={(event) => this.handleDiagChange(event, 'TSCTSIBEYEOPENFIRMSTRAT')}
                            defaultValue={ this.props.valueStratOpenFirm }>
                            <option key={-1} value='-1'></option>
                            <option key={1} value='1'>Hip</option>
                            <option key={2} value='2'>Ankle</option>
                            <option key={3} value='3'>Other</option>
                        </select>
                        <span className={styles.spacer} />
                        {this.props.showStratOpenFirm === true  && 
                            <span>
                                <DBTextField
                                field='TSCTSIBEYEOPENFIRMSTRAT'
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESPECTESTS'
                                entityKeyColumn='TSNO'
                                entityKeyValue={this.props.tsno}    
                                className={styles.r}
                            />
                            </span>
                    }

                </div>
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSCTSIBEYECLOSEFIRM} mopno={this.props.mopno} flagText='Special Test - mCTSIB'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Eyes Closed (30 Sec Firm Surface) </label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSCTSIBEYECLOSEFIRMTIME'
                        className={styles.out_measure_other}
                        />
                        <span className={styles.spacer} />
                        <select 
                            className={styles.diag_drop_down} 
                            onChange={(event) => this.handleDiagChange(event, 'TSCTSIBEYECLOSEFIRMSTRAT')}
                            defaultValue={ this.props.valueStratCloseFirm }>
                            <option key={-1} value='-1'></option>
                            <option key={1} value='1'>Hip</option>
                            <option key={2} value='2'>Ankle</option>
                            <option key={3} value='3'>Other</option>
                        </select>
                        <span className={styles.spacer} />
                        {this.props.showStratCloseFirm === true  && 
                            <span>
                                <DBTextField
                                field='TSCTSIBEYECLOSEFIRMSTRAT'
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESPECTESTS'
                                entityKeyColumn='TSNO'
                                entityKeyValue={this.props.tsno}    
                                className={styles.r}
                            />
                            </span>
                    }
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSCTSIBEYEOPENCOMP} mopno={this.props.mopno} flagText='Special Test - mCTSIB'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Eyes Open (30 Sec Compliant Surface)</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSCTSIBEYEOPENCOMPTIME'
                        className={styles.out_measure_other}
                        />
                         <span className={styles.spacer} />
                        <select className={styles.diag_drop_down} onChange={(event) => this.handleDiagChange(event, 'TSCTSIBEYEOPENCOMPSTRAT')} 
                        defaultValue={ this.props.valueStratOpenComp }>
                            <option key={-1} value='-1'></option>
                            <option key={1} value='1'>Hip</option>
                            <option key={2} value='2'>Ankle</option>
                            <option key={3} value='3'>Other</option>
                        </select>
                        <span className={styles.spacer} />
                        {this.props.showStratOpenComp === true  && 
                            <span>
                                <DBTextField
                                field='TSCTSIBEYEOPENCOMPSTRAT'
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESPECTESTS'
                                entityKeyColumn='TSNO'
                                entityKeyValue={this.props.tsno}    
                                className={styles.r}
                            />
                            </span>
                    }
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSCTSIBEYECLOSECOMP} mopno={this.props.mopno} flagText='Special Test - mCTSIB'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Eyes Closed (Compliant Surface)</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSCTSIBEYECLOSECOMPTIME'
                        className={styles.out_measure_other}
                        />
                         <span className={styles.spacer} />
                        <select className={styles.diag_drop_down} onChange={(event) => this.handleDiagChange(event, 'TSCTSIBEYECLOSECOMPSTRAT')}
                         defaultValue={ this.props.valueStratCloseComp }>
                            <option key={-1} value='-1'></option>
                            <option key={1} value='1'>Hip</option>
                            <option key={2} value='2'>Ankle</option>
                            <option key={3} value='3'>Other</option>
                        </select>
                        <span className={styles.spacer} />
                        {this.props.showStratCloseComp === true  && 
                            <span>
                                <DBTextField
                                field='TSCTSIBEYECLOSECOMPSTRAT'
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESPECTESTS'
                                entityKeyColumn='TSNO'
                                entityKeyValue={this.props.tsno}    
                                className={styles.r}
                            />
                            </span>
                    }
                </div>   
                <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedComments} mopno={this.props.mopno} flagText='Special Test - mCTSIB'/>
                <span className={styles.spacer} />
                <label className={styles.textarea_label} >Comments</label>
                <DBTextAreaObjective
                                field='TSCTSIBCOMMENT'
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESPECTESTS'
                                entityKeyColumn='TSNO'
                                entityKeyValue={this.props.tsno}    
                                className={styles.comment}
                            />
                </div>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch)
    };
}

function mapStateToProps(state) {
    let showStratOpenFirm = false;
    let showStratCloseFirm = false;
    let showStratOpenComp = false;
    let showStratCloseComp = false;


    let valueStratOpenFirm = -1;
    let valueStratCloseFirm = -1;
    let valueStratOpenComp = -1;
    let valueStratCloseComp = -1;

    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

            let flaggedTSCTSIBEYEOPENFIRM = false
            let flaggedTSCTSIBEYECLOSEFIRM = false
            let flaggedTSCTSIBEYEOPENCOMP = false
            let flaggedTSCTSIBEYECLOSECOMP = false
            let flaggedComments = false;
        
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT || state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMTIME) {
                flaggedTSCTSIBEYEOPENFIRM = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT || state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMTIME) {
                flaggedTSCTSIBEYECLOSEFIRM = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT || state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPTIME) {
                flaggedTSCTSIBEYEOPENCOMP = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT || state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPTIME) {
                flaggedTSCTSIBEYECLOSECOMP = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBCOMMENT) {
                flaggedComments = true;
            }
            
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT !== null &&
                state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT !== 'Ankle' &&
                state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT !== 'Hip') {
                    showStratOpenFirm = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT !== null &&
                state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT !== 'Ankle' &&
                state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT !== 'Hip') {
                    showStratCloseFirm = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT !== null &&
                state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT !== 'Ankle' &&
                state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT !== 'Hip') {
                    showStratOpenComp = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT !== null &&
                state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT !== 'Ankle' &&
                state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT !== 'Hip') {
                    showStratCloseComp = true;
            }

            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT === 'Hip') {
                valueStratOpenFirm = 1
            } 
            else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT === 'Ankle') {
                valueStratOpenFirm = 2
            } else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT !== null &&
                    state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT !== 'Ankle' &&
                    state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENFIRMSTRAT !== 'Hip') {
                    valueStratOpenFirm = 3
            }

            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT === 'Hip') {
                valueStratCloseFirm = 1
            } 
            else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT === 'Ankle') {
                valueStratCloseFirm = 2
            } else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT !== null &&
                    state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT !== 'Ankle' &&
                    state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSEFIRMSTRAT !== 'Hip') {
                    valueStratCloseFirm = 3
            }

            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT === 'Hip') {
                valueStratOpenComp = 1
            } 
            else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT === 'Ankle') {
                valueStratOpenComp = 2
            } else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT !== null &&
                    state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT !== 'Ankle' &&
                    state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYEOPENCOMPSTRAT !== 'Hip') {
                        valueStratOpenComp = 3
            }

            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT === 'Hip') {
                valueStratCloseComp = 1
            } 
            else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT === 'Ankle') {
                valueStratCloseComp = 2
            } else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT !== null &&
                    state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT !== 'Ankle' &&
                    state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCTSIBEYECLOSECOMPSTRAT !== 'Hip') {
                        valueStratCloseComp = 3
            }


    return {
        noteId: noteId,
        tsno: tsno,
        showStratOpenFirm,
        showStratCloseFirm,
        showStratOpenComp,
        showStratCloseComp,
        flaggedTSCTSIBEYEOPENFIRM :flaggedTSCTSIBEYEOPENFIRM,
        flaggedTSCTSIBEYECLOSEFIRM :flaggedTSCTSIBEYECLOSEFIRM,
        flaggedTSCTSIBEYEOPENCOMP :flaggedTSCTSIBEYEOPENCOMP,
        flaggedTSCTSIBEYECLOSECOMP :flaggedTSCTSIBEYECLOSECOMP,
        flaggedComments: flaggedComments,
        valueStratOpenFirm: valueStratOpenFirm,
        valueStratCloseFirm: valueStratCloseFirm, 
        valueStratOpenComp: valueStratOpenComp,
        valueStratCloseComp: valueStratCloseComp
    };
}

const connectedSpecialTestSpecialTestCTSIB = connect(mapStateToProps, mapDispatchToProps)(SpecialTestCTSIB);
export {connectedSpecialTestSpecialTestCTSIB as SpecialTestCTSIB };